// extracted by mini-css-extract-plugin
module.exports = {"borderBoxContainer":"box-layout_borderBoxContainer__1l-NE"};